export const DEFAULT_ODDS_EXPANDED: number = 5;
export const DEFAULT_BYPASS_LIVE_SIDEBAR: boolean = false;

export enum LIVE_SIDEBAR_COMPONENT {
    NAV = 'live-nav',
    LIST = 'live-list',
    MATCH = 'live-match',
}
